import CircleIcon from '@mui/icons-material/Circle';
import { IconButton, ListItem, ListItemButton, ListItemText, Typography } from '@mui/material';
import React from 'react';
import { MIXPANEL_EVENTS, Notification } from 'vendor-marketplace-shared-library';

import useMixpanel from '../../hooks/useMixpanel';
import { notificationTime } from '../../utilities/formatters';
import useNotificationRouting from '../../hooks/useNotificationRouting';

type NotificationRowProps = {
  onMarkAsRead: () => void;
  notification: Notification;
  handleClose: () => void;
};

export default function NotificationRow(props: NotificationRowProps) {
  const { mixpanelTrack } = useMixpanel();
  const navigateNotification = useNotificationRouting();

  const onClick = () => {
    navigateNotification(props.notification);
    mixpanelTrack(MIXPANEL_EVENTS.NAVIGATE_TO_NOTIFICATION);
    props.handleClose();
  };

  const onMarkAsRead = (e: React.MouseEvent) => {
    e.stopPropagation();
    props.onMarkAsRead();
  };

  return (
    <ListItem
      disablePadding
      onClick={onClick}
      secondaryAction={
        !props.notification.viewedAt ? (
          <IconButton edge='end' aria-label='read-indicator' onClick={onMarkAsRead}>
            <CircleIcon sx={{ height: 16, width: 16 }} color={'info'} />
          </IconButton>
        ) : null
      }
    >
      <ListItemButton>
        <ListItemText
          secondary={
            <Typography component={'p'} variant={'body2'} color={'text.secondary'}>
              {notificationTime(new Date(props.notification.createdAt))}
            </Typography>
          }
        >
          {props.notification.content}
        </ListItemText>
      </ListItemButton>
    </ListItem>
  );
}
